import { render, staticRenderFns } from "./ShiseidoProductCategory.vue?vue&type=template&id=82645a3c&scoped=true"
import script from "./ShiseidoProductCategory.vue?vue&type=script&lang=js"
export * from "./ShiseidoProductCategory.vue?vue&type=script&lang=js"
import style0 from "./ShiseidoProductCategory.vue?vue&type=style&index=0&id=82645a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82645a3c",
  null
  
)

export default component.exports